// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"271e2762","488":"2f6f1921"}[chunkId] + ".chunk.js";
};